import {
  ScanEventType,
  WebSocketClientOptions,
  WSConnection,
} from '@hakimo-ui/hakimo/types';
import { ScanWsContext, useWebsocketConnect } from '@hakimo-ui/hakimo/util';
import { ReactNode, useMemo } from 'react';

interface Props {
  url: string;
  getAccessToken?: () => Promise<string>;
  children: ReactNode;
}

export function ScanProvider(props: Props) {
  const { children, url, getAccessToken } = props;

  const websocketClientOptions: WebSocketClientOptions = useMemo(
    () => ({
      isDuplicateSessionAllowed: false,
      autoReconnect: true,
      dataTypeKey: 'event_type',
      batchDataTypes: [ScanEventType.HISTORY, ScanEventType.LLM_EVENT],
      retryConfig: {
        maxRetries: 20,
      },
    }),
    []
  );

  const { disconnect, send, subscribe, wsConnectionState, reconnect } =
    useWebsocketConnect(url, getAccessToken, websocketClientOptions);

  const contextVal: WSConnection = useMemo(
    () => ({
      connectionState: wsConnectionState,
      subscribe,
      send,
      disconnect,
      reconnect,
    }),
    [wsConnectionState, subscribe, send, disconnect, reconnect]
  );

  return (
    <ScanWsContext.Provider value={contextVal}>
      {children}
    </ScanWsContext.Provider>
  );
}
